import { useContext } from 'react';
import { AuthContext, AuthContextValue } from '../contexts/AuthContext';

export const useAuth = (): AuthContextValue => useContext(AuthContext);
